import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { api } from "../axios/api";
import { Logo2 } from "../static";

const ResetPassword = () => {
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation();
  const { email, code } = location.state || {};

  // Proteção de rota: redireciona se não houver estado (email/code)
  useEffect(() => {
    if (!email || !code) {
      navigate("/auth/solicitar-reset");
    }
  }, [email, code, navigate]);

  const handleReset = async (e) => {
    e.preventDefault();

    if (novaSenha !== confirmarSenha) {
      return Swal.fire("Atenção", "As senhas não coincidem.", "warning");
    }

    setLoading(true);
    try {
      await api.post("/auth/password/reset", { email, code, novaSenha });
      
      await Swal.fire({
        title: "Sucesso!",
        text: "Sua senha foi redefinida com sucesso.",
        icon: "success",
        confirmButtonColor: "#0078d4",
      });
      
      navigate("/login");
    } catch (err) {
      Swal.fire({
        title: "Erro",
        text: err.response?.data?.error || "Falha ao redefinir senha.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="facturize-auth-page min-vh-100 d-flex align-items-center justify-content-center">
      <div className="vignette" />
      
      <div className="facturize-setup-card p-4 col-12 col-md-4 animate__animated animate__fadeIn">
        <header className="text-center mb-4">
          <img src={Logo2} alt="Facturize" width="120" className="mb-3" />
          <h4 className="step-title">Criar Nova Senha</h4>
          <p className="text-muted small">Crie uma senha forte para sua conta.</p>
        </header>

        <form onSubmit={handleReset}>
          <div className="mb-3">
            <label className="auth-label">Nova Senha</label>
            <input
              type="password"
              className="auth-field"
              placeholder="********"
              value={novaSenha}
              onChange={(e) => setNovaSenha(e.target.value)}
              required
            />
          </div>

          <div className="mb-4">
            <label className="auth-label">Confirmar Nova Senha</label>
            <input
              type="password"
              className="auth-field"
              placeholder="********"
              value={confirmarSenha}
              onChange={(e) => setConfirmarSenha(e.target.value)}
              required
            />
          </div>

          <button type="submit" disabled={loading} className="btn-setup-primary w-100">
            {loading ? <span className="spinner-border spinner-border-sm"></span> : "Confirmar e Acessar"}
          </button>
        </form>
      </div>

      <style>{`
        .facturize-auth-page { background: #000b1a; font-family: 'Inter', sans-serif; position: relative; }
        .vignette { position: absolute; width: 100%; height: 100%; background: radial-gradient(circle at center, rgba(0, 86, 179, 0.15) 0%, #000b1a 100%); }
        .facturize-setup-card { background: #fff; border-radius: 16px; box-shadow: 0 10px 30px rgba(0,0,0,0.3); z-index: 1; }
        .step-title { font-weight: 800; color: #0f172a; }
        .auth-label { font-size: 11px; font-weight: 700; color: #64748b; margin-bottom: 8px; text-transform: uppercase; }
        .auth-field { width: 100%; padding: 12px; border: 1.5px solid #e2e8f0; border-radius: 12px; background: #f8fafc; transition: 0.2s; }
        .auth-field:focus { border-color: #0078d4; outline: none; box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.1); }
        .btn-setup-primary { background: #0078d4; color: white; border: none; padding: 12px; border-radius: 12px; font-weight: 700; transition: 0.2s; }
        .btn-setup-primary:hover:not(:disabled) { background: #005a9e; }
      `}</style>
    </div>
  );
};

export default ResetPassword;